import React from 'react';
import cx from 'classnames';
import styles from './Card.module.scss';

function CardExtra(props) {
  const { className, children, ...rest } = props;
  return (
    <div className={cx(styles.extra, className)} {...rest}>
      {children}
    </div>
  );
}

export default CardExtra;
